import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { JOURNEY_STEP_ACTIONS } from 'src/app/constants/journey-actions';

/**
 * The call to action of a journey step, resolved from `JOURNEY_STEP_ACTIONS`.
 *
 * Extracted so the step rows and the "next step" hero render the exact same target — a
 * route, possibly deep-linked into a tab or a content block — with only their emphasis
 * differing.
 */
@Component({
  selector: 'app-journey-step-cta',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslocoModule, LucideAngularModule],
  templateUrl: './journey-step-cta.component.html',
})
export class JourneyStepCtaComponent {
  stepKey = input.required<string>();
  /** Filled button instead of a discreet link, for the "next step" hero. */
  prominent = input(false);

  action = computed(() => JOURNEY_STEP_ACTIONS[this.stepKey()] ?? null);

  ctaClass = computed(() =>
    this.prominent()
      ? 'inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-lg bg-primary-600 px-4 py-2 text-paragraph-s-med text-white no-underline transition-colors hover:bg-primary-700'
      : 'inline-flex shrink-0 items-center gap-1 whitespace-nowrap bg-transparent text-paragraph-xs-med text-primary-600 no-underline transition-colors hover:text-primary-800 hover:underline',
  );
}
